import { Tabs, Tab } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import fiterAPI from '../../fiterAPI';
import UserHistoryDisplay from '../UserHistoryDisplay';
import UserInfoDisplay from '../UserInfoDisplay';

const SwitchTabs = props => {
  const { tabValue, userId } = props;
  switch (tabValue) {
    case 0:
      return <UserInfoDisplay userId={userId} />;
      break;
    case 1:
      return <UserHistoryDisplay userId={userId} />;
    default:
      break;
  }
};

export default function UserHistoryModal(props) {
  const { show, setShow, userId } = props;
  const [tabValue, setTabValue] = useState(1);

  return (
    <Modal show={show} size="xl" onHide={() => setShow(false)}>
      <Modal.Header closeButton />
      <Modal.Body>
        <Tabs
          value={tabValue}
          onChange={(e, newValue) => setTabValue(newValue)}
          aria-label="basic tabs example"
        >
          <Tab label="Perfil" value={0} />
          <Tab label="Linha do Tempo" value={1} />
        </Tabs>
        <SwitchTabs userId={userId} tabValue={tabValue} />
        {/* <UserInfoDisplay hidden={tabValue != 0} /> */}
      </Modal.Body>
    </Modal>
  );
}
